import request from '@/utils/request'

/**
 * 账户信息
 * @param {*} data
 * @returns
 */
export function getAccountInfo(data, headers) {
    return request({
        url: 'e126c8b0985129c68d',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 工作信息
 * @param {*} data
 * @returns
 */
export function updateApplyWork(data, headers) {
    return request({
        url: '652135da05592a4358',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 联系人信息
 * @param {*} data
 * @returns
 */
export function updateApplyContact(data, headers) {
    return request({
        url: 'fc66a9d28fe8b92917',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 邮编获取地区列表
 * @param {*} data
 * @returns
 */
export function postcodeGetCity(data, headers) {
    return request({
        url: '20aa545a9f25010781',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 上传个人信息
 * @param {*} data
 * @returns
 */
export function updateApplyProfilework(data, headers) {
    return request({
        url: 'de0a16d17e760544a1',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 银行下发列表
 * @param {*} data
 * @returns
 */
export function getBankList(data, headers) {
    return request({
        url: '2b697fa4e04ce22a1f',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 绑卡
 * @param {*} data
 * @returns
 */
export function updateBankCard(data, headers) {
    return request({
        url: 'fb8b3435f83126396e',
        method: 'post',
        data,
        headers,
    })
}

/**
 * 身份信息保存
 * @param {*} data
 * @returns
 */
export function verifyIdentity(data, headers) {
    return request({
        url: 'b7cbd0a6e62af05a72',
        method: 'post',
        data,
        headers,
    })
}


